import { render } from "./BranchSummary.vue?vue&type=template&id=41193730&scoped=true"
import script from "./BranchSummary.vue?vue&type=script&lang=js"
export * from "./BranchSummary.vue?vue&type=script&lang=js"

import "./BranchSummary.vue?vue&type=style&index=0&id=41193730&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41193730"]])

export default __exports__